// extracted by mini-css-extract-plugin
export var Heading = "HeadingComponent-module--Heading--9c06a";